import { defineMessages } from 'react-intl';

const messages = defineMessages({
    firstName: {
        id: 'InputFirstName.firstName',
        defaultMessage: 'Enter first name',
    },
    firstNameRequired: {
        id: 'InputFirstName.firstNameRequired',
        defaultMessage: 'First name required',
    },
    firstNameInvalid: {
        id: 'InputFirstName.firstNameInvalid',
        defaultMessage: 'First name must have 1 to 75 characters',
    },
});

export default messages;
